import React from "react"
import { Link } from "gatsby"
import MainLayout from "../../components/layout"
import SEO from "../../components/seo"
import "bootstrap/dist/css/bootstrap.min.css"
import GridView from "../../components/SubPages/GridViewSubPages/gridViewSubPages"
import Intro from "../../components/SubPages/IntroSubPages/introSubPages"
import Blogs from "../../components/SubPages/ServicesPage/BlogsCarousel/blogCarousel"
import Carousel from "../../components/SubPages/CarouselSubPages/carouselSubPages"
import backgroundIMG from "../../images/services/consultation/Custom_Communication_sys_image.png"
import CarouselImg1 from "../../images/services/consultation/servicecorsal1.png"
import CarouselImg2 from "../../images/services/consultation/servicecorsal2.png"
import CarouselImg3 from "../../images/services/consultation/servicecorsal3.png"
import clientimg1 from "../../images/services/consultation/David.png"
import clientimg2 from "../../images/services/consultation/kevin.png"
import clientimg3 from "../../images/services/consultation/guillaumepotier.png"
import Constants from "../../constants/services.json"
import Constants2 from "../../constants/careers.json"
import Consultpara from "../../components/SubPages/careerpage/paragraph"
import ServiceExperiance from "../../components/SubPages/ServicesPage/consultGrid/consultgrid"
const carouselData = [
  {
    clienttitle: Constants.ConsultationforWebRTC.carouselDataArray.i1.title,
    clientdescription:
      Constants.ConsultationforWebRTC.carouselDataArray.i1.description,
    img: CarouselImg3,
    clientimg: clientimg3,
  },
  {
    clienttitle: Constants.ConsultationforWebRTC.carouselDataArray.i2.title,
    clientdescription:
      Constants.ConsultationforWebRTC.carouselDataArray.i2.description,
    img: CarouselImg1,
    clientimg: clientimg2,
  },
  {
    clienttitle: Constants.ConsultationforWebRTC.carouselDataArray.i3.title,
    clientdescription:
      Constants.ConsultationforWebRTC.carouselDataArray.i3.description,
    img: CarouselImg2,
    clientimg: clientimg1,
  },
]

const ConsultForWebrtc = () => (
  <MainLayout>
    <SEO
      title="Consultation for WebRTC Project"
      description="Install, customize and configure Jitsi meet according to your requirement. Different packages are available based on your requirement. Technical support needed to install, configure, debug and implement new features with Jitsi and it’s components. Meetrix commercial Support for Jitsi online conference. how to customize jitsi meet
            zoom alternative open source"
      pagePath="/services/consultation-for-WebRTC-Project"
      schema={`{
              "@context": "https://meetrix.io/services/consultation-for-WebRTC-Project",
              "@type": "WebPage",
              "mainEntity": {
                "@type": "Organization",
                "name": "Meetrix.io",
              }
            }`}
    />
    <Intro
      title={Constants.ConsultationforWebRTC.MainLayout.title}
      description={Constants.ConsultationforWebRTC.MainLayout.description}
      blueTitle={Constants.ConsultationforWebRTC.MainLayout.blueTitle}
      blueLink=""
      // yellowTitle={Constants.CommercialSupportForJitsi.MainLayout.yellowTitle}
      yellowLink=""
      background={backgroundIMG}
    />
    <Consultpara />
    <ServiceExperiance
      righttxt1={Constants.ConsultationforWebRTC.ServiceExperiance.r1.righttxt1}
      righttxt2={Constants.ConsultationforWebRTC.ServiceExperiance.r1.righttxt2}
      righttxt3={Constants.ConsultationforWebRTC.ServiceExperiance.r1.righttxt3}
      righttxt4={Constants.ConsultationforWebRTC.ServiceExperiance.r1.righttxt4}
      righttxt5={Constants.ConsultationforWebRTC.ServiceExperiance.r1.righttxt5}
      righttxt6={Constants.ConsultationforWebRTC.ServiceExperiance.r1.righttxt6}
      righttxt7={Constants.ConsultationforWebRTC.ServiceExperiance.r1.righttxt7}
      righttxt8={Constants.ConsultationforWebRTC.ServiceExperiance.r1.righttxt8}
      righttxt9={Constants.ConsultationforWebRTC.ServiceExperiance.r1.righttxt9}
    />
    <ServiceExperiance
      lefttxt1={Constants.ConsultationforWebRTC.ServiceExperiance.l1.lefttxt1}
      lefttxt2={Constants.ConsultationforWebRTC.ServiceExperiance.l1.lefttxt2}
      lefttxt3={Constants.ConsultationforWebRTC.ServiceExperiance.l1.lefttxt3}
      lefttxt4={Constants.ConsultationforWebRTC.ServiceExperiance.l1.lefttxt4}
      lefttxt5={Constants.ConsultationforWebRTC.ServiceExperiance.l1.lefttxt5}
      lefttxt6={Constants.ConsultationforWebRTC.ServiceExperiance.l1.lefttxt6}
      lefttxt7={Constants.ConsultationforWebRTC.ServiceExperiance.l1.lefttxt7}
      lefttxt8={Constants.ConsultationforWebRTC.ServiceExperiance.l1.lefttxt8}
      lefttxt9={Constants.ConsultationforWebRTC.ServiceExperiance.l1.lefttxt9}
      lefttxt10={Constants.ConsultationforWebRTC.ServiceExperiance.l1.lefttxt10}
      lefttxt11={Constants.ConsultationforWebRTC.ServiceExperiance.l1.lefttxt11}
      lefttxt12={Constants.ConsultationforWebRTC.ServiceExperiance.l1.lefttxt12}
      // lefttxt13={Constants.ConsultationforWebRTC.ServiceExperiance.l1.lefttxt13}
    />
    <Carousel data={carouselData} />
  </MainLayout>
)

export default ConsultForWebrtc
